import { User } from 'firebase/auth';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from 'react';

export interface IUser {
  uid: string;
  email: string;
  displayName: string;
  providerDataId?: string;
  providerId: 'google.com' | 'apple.com';
  isAppleAuth: boolean;
  isGoogleAuth: boolean;
}

export const UserContext = createContext<null | {
  user: null | IUser;
  setUser: Dispatch<SetStateAction<IUser | null>>;
  firebaseUserCredential: User | null;
  setFirebaseUserCredential: React.Dispatch<React.SetStateAction<User | null>>;
}>(null);

UserContext.displayName = 'UserContext';

function UserProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<null | IUser>(null);

  const [firebaseUserCredential, setFirebaseUserCredential] =
    useState<User | null>(null);

  const value = {
    user,
    setUser,
    firebaseUserCredential,
    setFirebaseUserCredential,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export default UserProvider;
